import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  Divider,
  Typography,
  Grid
} from '@material-ui/core';
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import { CloseableDialogTitle } from 'components/layout';
import { compose } from 'redux';
import { connect } from "react-redux";

const styles = theme => ({ 
  content: {
    paddingTop: 16
  },
  gridRoundedContainer: {
    border: '1px solid #0000008a',
    borderRadius: '4px'
  },
  gridRow: {
    borderTop: '1px solid #0000008a',
    paddingRight: 10,
    '&:nth-child(1)' : {
      borderTop: 'none',
    },
  },
  gridRowContent: {
    marginLeft: 10, 
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center', /* Vertical center alignment */
    lineHeight: '2',
  },
  gridColumnHeader: {
    fontWeight: 800,
    display: 'flex',
    alignItems: 'center', /* Vertical center alignment */
    justifyContent: 'center', /* Horizontal center alignment */
    lineHeight: '2',
  },
  gridColumnHeaderLeft: {
    marginLeft: 10, 
    fontWeight: 800,
    display: 'flex',
    alignItems: 'center', /* Vertical center alignment */
    lineHeight: '2',
  },
  gridColumn: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center', /* Vertical center alignment */
    justifyContent: 'center', /* Horizontal center alignment */
  },
});

const ProfileDialog = ({ classes, onClose, ...props }) => {

  return (
    <Dialog onClose={onClose} {...props} fullScreen={props.isMobile}>
      <CloseableDialogTitle id="about-dialog-title" onClose={onClose}>
        <Typography variant='h6' style={{ marginRight: 8 }}>Profile</Typography>
      </CloseableDialogTitle>
      <Divider />
      <DialogContent className={classes.content}>
          {
            props.user && 
              <DialogContentText>
                User: <strong>{props.user ? props.user.fullName || props.user.name : ''}</strong>
              </DialogContentText>
          }  
          {
            props.user && props.user.email &&
              <DialogContentText>
                Email: <strong>{props.user ? props.user.email : ''}</strong>
              </DialogContentText>
          }      
          {
            props.user && props.user.userRoles &&
            <DialogContentText>
             <strong>{getUserRoles(props.user, classes)}</strong>
            </DialogContentText>
          }    
      </DialogContent>
    </Dialog>
  );
};

const mapState = (state) => {
  return {
    isMobile: state?.appState?.isMobile,
  };
}

const getUserRoles = (user, classes) => {  
  return (  
    <Grid container className={classes.gridRoundedContainer}>
      <Grid container item xs={12} className={classes.gridRow}>
        <Grid item xs={6}>
          <div className={classes.gridColumnHeaderLeft}><strong>Role Name</strong></div>
        </Grid>
        <Grid item xs={user.roles.administrator ? 3 : 0} style={{display: user.roles.administrator ? 'inline-block' : 'none'}}>
          <div className={classes.gridColumnHeader}><strong>ReVUe</strong></div>
        </Grid>
        <Grid item xs={user.roles.administrator ? 3 : 6}>
          <div className={classes.gridColumnHeader}><strong>Assigned (Okta)</strong></div>
        </Grid>
      </Grid>
      {
        user.userRoles.map((r, index) => (
          <Grid container item xs={12} className={classes.gridRow} key={`row-${index}`}>
            <Grid item xs={6}>
              <Typography className={classes.gridRowContent} key={index}><strong>{r.description}</strong></Typography>
            </Grid>
            <Grid item xs={user.roles.administrator ? 3 : 0} style={{display: user.roles.administrator ? 'inline-block' : 'none'}}>
              <Typography className={classes.gridColumn}>{r.isReVueRole ? <CheckIcon /> : <CloseIcon />}</Typography>
            </Grid>
            <Grid item xs={user.roles.administrator ? 3 : 6}>
              <Typography className={classes.gridColumn}>{r.isOktaRole ? <CheckIcon /> : <CloseIcon />}</Typography>
            </Grid>
          </Grid>
        ))
      }
    </Grid>
  );  
}

export default compose(withStyles(styles), connect(mapState))(ProfileDialog);
